import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    list: [],
}

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrders: (state, action) => {
            state.list = action.payload ?? []
        }
    },
})

export const { setOrders } = orderSlice.actions

export default orderSlice.reducer